<template>
  <div class="cartContent">
    <div class="cartContent--rwdM">
      <ul class="list">
        <li class="item" v-for="(item, index) in connectObj.products"
        :key="index">
          <div class="item__main">
            <div class="item__delete" v-if="editable">
              <a href="#" @click.prevent='edit_quantity(0, index)'>
                <img src="@/assets/icon/remove_item.png" alt="">
              </a>
            </div>
            <div class="item__img">
              <img :src="item.img" alt="">
            </div>
            <div class="item__info">
              <div class="item__header">
                <p class="item__title">{{item.title}}</p>
                <p class="item__id">{{item.id}}</p>
                <p class="item__price">NT${{item.price}}</p>
              </div>
              <div class="item__quantity">
                <span>數量: </span>
                <b-form-spinbutton v-if="editable"
                @change="edit_quantity($event, index)"
                v-model="item.quantity"
                min="0" max="100"></b-form-spinbutton>
                <span class="number"
                 v-if="!editable">{{item.quantity}}</span>
              </div>
            </div>
          </div>
          <p class="item__delivery">黑貓宅急便、專人配送、門市取貨</p>
        </li>
      </ul>
    </div>
    <div class="cartContent--rwdL">
      <table class="table">
        <thead>
          <tr>
            <th>產品名稱</th>
            <th>編號</th>
            <th>單價</th>
            <th>數量</th>
            <th>小計</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in connectObj.products"
          :key="index">
            <td>
              <div class="table__info">
                <div class="table__delete" v-if="editable">
                  <a href="#" @click.prevent='edit_quantity(0, index)'>
                    <img src="@/assets/icon/remove_item.png" alt="">
                  </a>
                </div>
                <div class="table__img">
                  <img :src="item.img" alt="">
                </div>
                <div class="table__main">
                  <p class="table__title">{{item.title}}</p>
                  <p class="table__delivery">黑貓宅急便、專人配送、門市取貨</p>
                </div>
              </div>
            </td>
            <td>
              <div class="table__div">
                {{item.id}}
              </div>
            </td>
            <td>
              <div class="table__div">
                NT${{item.price}}
              </div>
            </td>
            <td>
              <div class="table__div">
                <div class="table--editable" v-if="editable">
                  <b-form-spinbutton v-model="item.quantity"
                  @change="edit_quantity($event, index)"
                  min="0" max="100"></b-form-spinbutton>
                </div>
                <div class="table--confirm" v-if="!editable">
                  {{item.quantity}}
                </div>
              </div>
            </td>
            <td>
              <div class="table__div">
                NT${{item.quantity * item.price}}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['editable', 'connectObj'],
  computed: {
    cart() {
      let cart;
      this.$bus.$on('get_cart', (data) => {
        cart = data;
      });
      this.$bus.$emit('call_cart');
      return cart;
    },
  },
  methods: {
    edit_quantity(num, index) {
      if (num === 0) {
        this.cart.products.splice(index, 1);
      }
      this.$bus.$emit('editCart');
    },
  },
};
</script>
